import React from 'react';
import PropTypes from 'prop-types';
import { MembersView } from '../../../../components';

const Members = ({
  membersList, onInviteMember, onDeleteMember, t, isPendingDelete, isPendingInvite,
}) => (
  <>
    <MembersView
      titleMain="Project"
      titleItem="member"
      onInviteMember={onInviteMember}
      isPendingDelete={isPendingDelete}
      isPendingInvite={isPendingInvite}
      onDeleteMember={onDeleteMember}
      membersList={membersList}
      t={t}
    />
  </>
);

Members.propTypes = {
  membersList: PropTypes.arrayOf(PropTypes.number).isRequired,
  onInviteMember: PropTypes.func.isRequired,
  onDeleteMember: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isPendingDelete: PropTypes.bool.isRequired,
  isPendingInvite: PropTypes.bool.isRequired,
};


export default Members;
